<template>
  <modal>
    <template v-slot:header>
      <h3 class="modal-title">
        Activiteit
        <span v-if="child">{{ child.first_name }}</span>
      </h3>
    </template>
    <template v-slot:body>
      <div style="padding: 20px">
        <div v-if="showActivityRequiredWarning" class="alert alert-danger mb-2">
          Selecteer eerst een activiteit voordat je kinderen kunt koppelen.
        </div>
        <div v-if="showChildRequiredWarning" class="alert alert-danger mb-2">
          Selecteer eerst minimaal één kind voordat je kunt opslaan.
        </div>
        <activities-form
          :formStep="formStep"
          :saveActivity="saveActivity"
          :activity="activity"
          :child="child"
          @saveLoading="changeSaveLoading($event)"
          @activityTypeChange="selectedActivityType = $event; showActivityRequiredWarning = false"
          @childrenSelectedChange="selectedChildren = $event; showChildRequiredWarning = false"
          @saveActivity="activitySaved"
        ></activities-form>
      </div>
    </template>
    <template v-slot:footer>
      <div>
        <button type="button" class="btn btn-outline-info me-1" :disabled="saveLoading" @click="$emit('close')">
          Annuleren
        </button>
        <button v-if="formStep === 1 && !child && !activity" type="button" class="btn btn-info me-1" @click="goToChildSelection()">
          Koppel kinderen
        </button>
        <button v-if="formStep === 2 || child || activity" type="button" class="btn btn-info" :disabled="saveLoading" @click="trySaveActivity()">
          <icon v-if="saveLoading" name="loading"></icon> Opslaan
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import ActivitiesForm from '@/views/activities/Form'
import Icon from '@/components/Icon'

export default {
  name: 'activity-modal',
  components: {
    Modal,
    ActivitiesForm,
    Icon
  },
  props: ['activity', 'child'],
  emits: ['close', 'saved'],
  data () {
    return {
      formStep: 1,
      saveActivity: false,
      saveLoading: false,
      selectedActivityType: null,
      showActivityRequiredWarning: false,
      selectedChildren: [],
      showChildRequiredWarning: false
    }
  },
  methods: {
    goToChildSelection () {
      if (!this.selectedActivityType) {
        this.showActivityRequiredWarning = true
        return
      }
      this.formStep = 2
    },
    trySaveActivity () {
      if (!this.selectedActivityType) {
        this.showActivityRequiredWarning = true
        return
      }
      if (this.formStep === 2 && this.selectedChildren.length === 0) {
        this.showChildRequiredWarning = true
        return
      }
      this.saveActivity = true
    },
    changeSaveLoading (loadingState) {
      this.saveLoading = loadingState
      if (loadingState === false) {
        this.saveActivity = false
      }
    },
    activitySaved () {
      this.saveActivity = false
      this.saveLoading = false
      this.$emit('saved')
    }
  }
}
</script>
